import { useForm } from "react-hook-form";
import type { Transactions } from "../../types/Transaction";
import { FloatingInputBootStrap, FloatingPostfixInputBootStrap } from "../Common/FloatingInputBootstrap";
import { useAddTransactionMutation } from "../../stores/OkOkStore";
import { Navigate } from "react-router";
import { useTrads } from "../../contexts/trads/useTrads";

interface Props  {
    transactionParam: Partial<Transactions>;
    
};
function TransactionForm({transactionParam}: Props){
    const { register, handleSubmit, formState: { errors } } = useForm({
        defaultValues:transactionParam,
        //shouldUseNativeValidation: true,
        mode:'onBlur',
    });
    const {translate}=useTrads();
    const [addTransaction,result]=useAddTransactionMutation();

    return (
        result.isSuccess ? <Navigate to={`/transactions/${transactionParam.fond_id?transactionParam.fond_id.toString():''}`} state={{modified:"true"}}></Navigate> :(
        result.error ? <p className="p-3 mb-2 bg-danger text-white">{translate('page_load_error')}</p> :
        result.isLoading ? <p className="p-3 mb-2 bg-info text-white">{translate('page_loading')}</p> :
        <form className="row" onSubmit={(event) => void handleSubmit(addTransaction)(event) }>
            <div className="col-12  mb-3">
                <FloatingInputBootStrap 
                    name="communication"
                    label={translate('transaction_communication')}
                    type="text"
                    registerOutput={register("communication", {
                    required: translate("transaction_error_communication_requis"),
                    minLength: 2
                    })}
                    errors={errors}
                
                />
            </div>
            <div className="col-12  mb-3">
                <FloatingPostfixInputBootStrap 
                    name="montant"
                    label={translate('transaction_montant')}
                    type="number"
                    prefix="€"
                    registerOutput={register("montant", {
                        required: translate("transaction_error_montant_requis"),
                    })} 
                    errors={errors}
                    rest={{"step":"0.01"}}
                />
            </div>
            <div className="col-12  mb-3">
                <button type="submit">{translate('form_submit')}</button>
            </div>
        </form>
        )
    );
}
export default TransactionForm;